export const yesno =
    [
        {
            id: "true", ime: "Да"
        },
        {
            id: "false", ime: "Не"
        }
    ]